module.exports = __webpack_public_path__ + "static/img/bg.abc26de9.png";